<template>
  <div class="left-menu greal-left">
    <!--左侧栏-->
    <el-row :sysName="sysName" class="tac">
      <el-col :span="24">
        <el-menu
          :default-active="active"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          text-color="#000"
          :router="true"
          :collapse-transition="true"
          :unique-opened="true"
          active-text-color="#fff">
          <el-menu-item :route="{name:'Software'}" index="Software">
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">软件概述</a></span>
          </el-menu-item>
           <el-menu-item :route="{name:'RunEnvironment'}" index="RunEnvironment">
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">运行环境</a></span>
          </el-menu-item>
          <el-menu-item :route="{name:'UserMessage'}" index="UserMessage">
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">用户注册与登录</a></span>
          </el-menu-item>
          <el-submenu  index="ImageHospital">
            <template slot="title">
              <span>资料中心</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :route="{name:'ImageHospital'}" index="ImageHospital"><a class="jump" href="javascript:void(0)">本院影像</a></el-menu-item>
              <el-menu-item :route="{name:'TypicalBank'}" index="TypicalBank"><a class="jump" href="javascript:void(0)">典型病例库</a></el-menu-item>
              <el-menu-item :route="{name:'TeachWare'}" index="TeachWare"><a class="jump" href="javascript:void(0)">教学课件</a></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="DailyReading">
            <template slot="title">
              <span>读片管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :route="{name:'DailyReading'}" index="DailyReading"><a class="jump" href="javascript:void(0)">每日读片</a></el-menu-item>
              <el-menu-item :route="{name:'ThematicReading'}" index="ThematicReading"><a class="jump" href="javascript:void(0)">专题读片</a></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
         <el-menu-item :route="{name:'ManageTeach'}" index="ManageTeach">
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">教学管理</a></span>
          </el-menu-item>
          <el-submenu index="ExcellentCourse">
            <template slot="title">
              <span>教学中心</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :route="{name:'ExcellentCourse'}" index="ExcellentCourse"><a class="jump" href="javascript:void(0)">精品好课</a></el-menu-item>
              <el-menu-item :route="{name:'ThematicRead'}" index="ThematicRead"><a class="jump" href="javascript:void(0)">名师讲堂</a></el-menu-item>
              <el-menu-item :route="{name:'MyCollection'}" index="MyCollection"><a class="jump" href="javascript:void(0)">我的收藏</a></el-menu-item>
              <el-menu-item :route="{name:'Mylearn'}" index="Mylearn"><a class="jump" href="javascript:void(0)">我的学习</a></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
           <el-menu-item :route="{name:'Audio'}" index="Audio">
            <span slot="title"><a class="jump Difjump" href="javascript:void(0)">音视频</a></span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getActive} from '@/common/js/active'
  export default {
    name: 'Homepage',
    data () {
      return {
        active: ''
      }
    },
    props: {
      sysName: {
        type: String,
        default: ''
      }
    },
    mounted() {
      // setTimeout(() => {
      //   this._getLeftH()
      // }, 20)

      // window.addEventListener('resize', () => {
      //   this._getLeftH()
      // })
    },
    methods: {
      handleOpen(key, keyPath) {
        // console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath)
      },
      // _getLeftH() {
      //   let height = document.getElementById('app').clientHeight
      //   let left = document.getElementsByClassName('left')
      //   left[0].style.height = height + 'px'
      // },
      _getActive() {
        let act = this.$route.matched[1].path.split('/')
        this.active = act[2]
      }
    },
    created() {
      this._getActive()
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .systemLogo
    height: 50px
    background: #122248
    overflow: hidden
    .logoText
      line-height: 50px
      color: $color-index-text
      font-size: $font-size-medium-x
      float: left
    .logoImg
      width: 30px
      height: 30px
      margin: 10px 13px
      float: left
      border-radius: 50%
  .left
    height: 100%
    background: $color-background-d-left
    overflow-y: auto
    overflow-x: hidden

  .text-color
    color: $color-text
  .greal-left
    height:calc(100vh - 80px)
    background :#fff
    border-right:1px solid #cccccc
    width:20%
    float: left

</style>



// WEBPACK FOOTER //
// helpMenu.vue?49bfcd4d